"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _menu = require("../utils/menu");
var _editRequester = _interopRequireDefault(require("./editRequester"));
var _constant = require("../constant");
var _common = require("../utils/common");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } } /* eslint-disable no-underscore-dangle */
/**
 * 数据管理的编辑扩展类
 */
var CopyRequester = /*#__PURE__*/function (_EditRequester) {
  (0, _inherits2.default)(CopyRequester, _EditRequester);
  var _super = _createSuper(CopyRequester);
  function CopyRequester() {
    (0, _classCallCheck2.default)(this, CopyRequester);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(CopyRequester, [{
    key: "copyAllDataDetail",
    value:
    /**
    * 全量的复制数据，即整个数据树的完全新建（这里不能区分那些要引用已有数据 -- 复制只能是全量的）
    */
    function () {
      var _copyAllDataDetail = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(oldList) {
        var i;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // 新数据的主键值，根据扩展配置来清空
              for (i = 0; i < oldList.length; i++) {
                this.clearPrimaryKeyAndRelation(oldList[i], this.tableTree);
              }
              return _context.abrupt("return", oldList);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function copyAllDataDetail(_x) {
        return _copyAllDataDetail.apply(this, arguments);
      }
      return copyAllDataDetail;
    }()
    /**
     * 清理主键，用于复制整颗数据树的新增
     * @param {*} $data 要复制的单条数据
     * @param {*} table table实例
     * @param {*} parentRelationObj 当前table与父节点的关系
     * @param {*} parentData 关联的父节点数据
     * @param {*} parentTableKey 关联的父表key
     * @param {*} isParentCreate 关联的父节点是否新建
     */
  }, {
    key: "clearPrimaryKeyAndRelation",
    value: function clearPrimaryKeyAndRelation($data, table, parentRelationObj, parentData, parentTableKey, isParentCreate) {
      var _this = this;
      var data = $data;
      var tableExtendInfo = table.tableExtendInfo,
        primaryKey = table.primaryKey,
        rawPrimaryKey = table.rawPrimaryKey;
      var copyType = tableExtendInfo.copyType;
      var isCreate = false;
      if (parentRelationObj && parentData) {
        // 不是根节点
        if (copyType === 2) {
          // 从表标记为复制时，清理主键值
          data[primaryKey] = undefined;
          (0, _common.setValueByPath)(data, rawPrimaryKey, undefined);
          isCreate = true;
        }
        // 处理父子数据的关联键清空
        this.clearRelationData(data, parentRelationObj, isCreate, parentData, parentTableKey, isParentCreate);
      } else {
        // 根节点直接清理主键值
        data[primaryKey] = undefined;
        (0, _common.setValueByPath)(data, rawPrimaryKey, undefined);
        isCreate = true;
      }

      // 遍历子表的数据集，进行同样的处理（递归）
      table.forkTableList.forEach(function (forkTableObj) {
        var relationObj = forkTableObj.relationObj,
          forkTable = forkTableObj.forkTable;
        var newForkDataList = data["".concat(_constant.TABLETAG).concat(forkTable.tableKey)] || [];
        // 1对1关系：挂的是对象形式，要转成数组处理
        if (!Array.isArray(newForkDataList)) {
          newForkDataList = [newForkDataList];
        }
        newForkDataList.forEach(function (forkData) {
          _this.clearPrimaryKeyAndRelation(forkData, forkTable, relationObj, data, table.tableKey, isCreate);
        });
      });
    }

    /**
     * 清空引用方存储的关联键值（原则是模拟新建、所以会清理一波关联键值）
     * @param {*} $curData 当前节点的数据
     * @param {*} parentRelationObj 与父节点的关联键值数据
     * @param {*} isCreate 当前节点是否新建
     * @param {*} $parentData 父节点的数据
     * @param {*} parentTableKey 父节点的表key
     * @param {*} isParentCreate 父节点是否新建
     */
  }, {
    key: "clearRelationData",
    value: function clearRelationData($curData, parentRelationObj, isCreate, $parentData, parentTableKey, isParentCreate) {
      var curData = $curData;
      var parentData = $parentData;
      var relation = parentRelationObj.relation,
        childTableKey = parentRelationObj.childTableKey,
        ratio = parentRelationObj.ratio,
        rawRatio = parentRelationObj.rawRatio;
      if (!isParentCreate && !isCreate) {
        // 父子节点都是引用的，就不用清理关联关系
        return;
      }
      if (ratio === 1) {
        if (rawRatio === 1 && isParentCreate !== isCreate) {
          if (isParentCreate !== isCreate) {
            throw Error("".concat(parentTableKey, "\u4E0E").concat(childTableKey, "\u662F1\u5BF91\u5173\u7CFB\uFF1B\u5173\u8054\u6570\u636E\u7684\u590D\u5236\u914D\u7F6E\u9700\u4E00\u81F4"));
          }
        } else if (rawRatio === 2 && !isParentCreate && isCreate) {
          throw Error("".concat(parentTableKey, "\u4E0E").concat(childTableKey, "\u662F\u591A\u5BF91\u5173\u7CFB\uFF1B").concat(parentTableKey, "\u5F15\u7528\uFF0C").concat(childTableKey, "\u590D\u5236 === \u6539\u53D8\u539F\u6570\u636E\u7684\u5173\u8054\u5173\u7CFB"));
        }
      }

      // 普通关联的键在子表
      if (relation[1] === _menu.RelationStatus.RIGHT) {
        if (isParentCreate && isCreate) {
          (0, _common.setValueByPath)(curData, relation[2], undefined);
          return;
        }
        if (!isParentCreate && isCreate) {
          // 1对多：“多”允许新增，保持关联关系
        } else if (isParentCreate && !isCreate) {
          throw Error("".concat(parentTableKey, "\u4E0E").concat(childTableKey, "\u662F1\u5BF9\u591A\u5173\u7CFB\uFF1B").concat(parentTableKey, "\u590D\u5236\uFF0C").concat(childTableKey, "\u5F15\u7528 === \u6539\u53D8\u539F\u6570\u636E\u7684\u5173\u8054\u5173\u7CFB"));
        }
      }
      // 普通关联的键在父表
      if (relation[1] === _menu.RelationStatus.LEFT) {
        if (isParentCreate && isCreate) {
          (0, _common.setValueByPath)(parentData, relation[0], undefined);
          return;
        }
        if (!isParentCreate && isCreate) {
          throw Error("".concat(childTableKey, "\u4E0E").concat(parentTableKey, "\u662F1\u5BF9\u591A\u5173\u7CFB\uFF1B").concat(childTableKey, "\u590D\u5236\uFF0C").concat(parentTableKey, "\u5F15\u7528 === \u6539\u53D8\u539F\u6570\u636E\u7684\u5173\u8054\u5173\u7CFB"));
        } else if (isParentCreate && !isCreate) {
          // 1对多：“多”允许新增，保持关联关系
        }
      }

      // ---------------------------------------------------------------
      // link关联的键在子表
      if (relation[1] === _menu.RelationStatus.IN) {
        if (isParentCreate && isCreate) {
          (0, _common.setValueByPath)(curData, relation[2], undefined);
          return;
        }
        if (!isParentCreate && isCreate) {
          // link关联允许只有子表复制，因为关联键存储在子表不会破坏愿数据
          (0, _common.setValueByPath)(curData, relation[2], undefined);
        } else if (isParentCreate && !isCreate) {
          // 保持关联关系（子表能补上正确的父表关联键值？）
        }
      }
      // link关联的键在父表
      if (relation[1] === _menu.RelationStatus.INCLUDE) {
        if (isParentCreate && isCreate) {
          (0, _common.setValueByPath)(parentData, relation[0], undefined);
          return;
        }
        if (!isParentCreate && isCreate) {
          // 保持关联关系（父表能补上正确的子表关联键值？）
        } else if (isParentCreate && !isCreate) {
          // 原理同上（link关联）
          (0, _common.setValueByPath)(parentData, relation[0], undefined);
        }
      }
    }
  }]);
  return CopyRequester;
}(_editRequester.default);
var _default = CopyRequester;
exports.default = _default;